import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "personal-area-table-pagination" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled", "onClick"]
const _hoisted_4 = ["disabled"]

import { computed } from 'vue';
import PaginationLeftIcon from '@/js/components/icons/PaginationLeftIcon.vue';
import PaginationRightIcon from '@/js/components/icons/PaginationRightIcon.vue';

type PageItem = number | '...';


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    modelValue: {},
    totalCount: {},
    pageSize: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentPage = computed(() => props.modelValue);

const totalPages = computed(() => Math.ceil(props.totalCount / props.pageSize));

const visiblePages = computed<PageItem[]>(() => {
  const total = totalPages.value;
  const current = currentPage.value;

  if (total <= 6) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages: PageItem[] = [1];

  if (current > 4) pages.push('...');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (current < total - 3) pages.push('...');

  pages.push(total);

  return pages;
});

function goToPage(page: number) {
  const safePage = Math.max(1, Math.min(page, totalPages.value));
  emit('update:modelValue', safePage);
  emit('change', safePage);
}

function onClick(page: PageItem) {
  if (page === '...') return;
  goToPage(page);
}

function pageKey(page: PageItem) {
  return typeof page === 'number' ? page : `dots-${Math.random()}`;
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "personal-area-table-pagination__previous",
      disabled: currentPage.value === 1,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(currentPage.value - 1)))
    }, [
      _createVNode(PaginationLeftIcon)
    ], 8, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
      return (_openBlock(), _createElementBlock("button", {
        key: pageKey(page),
        class: _normalizeClass(["personal-area-table-pagination__page", { active: page === currentPage.value }]),
        disabled: page === '...',
        onClick: ($event: any) => (onClick(page))
      }, _toDisplayString(page), 11, _hoisted_3))
    }), 128)),
    _createElementVNode("button", {
      class: "personal-area-table-pagination__next",
      disabled: currentPage.value === totalPages.value,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(currentPage.value + 1)))
    }, [
      _createVNode(PaginationRightIcon)
    ], 8, _hoisted_4)
  ], 512)), [
    [_vShow, props.totalCount > 0]
  ])
}
}

})